/* eslint-disable camelcase */
import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import SignupButton from '@segment/matcha/recipes/SignupButton'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Twilio Developer Plan`,
  heading: `Unify your customer data with Segment and Twilio`,
  description: `Build a centralized data pipeline for your web, app, and Twilio or Sendgrid campaign data with the Twilio Developer Plan from Segment`,
  cta: {
    text: `Sign up for free`,
  },
}

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <StyledHero variant="2Col">
        <HeroRecipe.Copy>
          <Overline tag="h5" variant="h5">
            {copy.overline}
          </Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <SignupButton additionalParams={{ twilio_developer_offer: `1` }}>{copy.cta.text}</SignupButton>
          </HeroRecipe.Form>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="480" height="560" src={heroPng2x} alt="Twilio Developer Plan" loading="lazy" />
          </picture>
        </HeroRecipe.Contents>
      </StyledHero>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHero = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    align-items: start;
  }
`

const Overline = styled(CopyText.Overline)`
  margin-top: 0;
`

export default Hero
